import script from "./StepShell.vue?vue&type=script&setup=true&lang=ts"
export * from "./StepShell.vue?vue&type=script&setup=true&lang=ts"

import "./StepShell.vue?vue&type=style&index=0&id=350b53b3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-350b53b3"]])

export default __exports__